/**
 * Categories actions types
 */

export const CATEGORIES_REQUESTED = '[CATEGORIES] REQUESTED';
export const CATEGORIES_SUCCEEDED = '[CATEGORIES] SUCCEEDED';
export const CATEGORIES_FAILED = '[CATEGORIES] FAILED';
